module.exports = __webpack_public_path__ + "static/img/27.e44e4536.png";